<template>
    <el-container>
        <el-main>
            <el-form :model="searchData" label-position="top" label-width="80px">
                <el-row :gutter="0">
                    <el-col :span="4">
                        <el-form-item label="字典标签" prop="dictLabel">
                            <el-input
                            v-model="searchData.dictLabel"
                            placeholder="请输入字典标签"
                            clearable
                            @keyup.enter.native="handleQuery"
                            />
                        </el-form-item>
                    </el-col>
                    <el-col :span="4">
                        <el-form-item label="状态" prop="status">
                            <el-select v-model="searchData.status" placeholder="数据状态" clearable>
                                <el-option key="0" label="可用" value="0"/>
                                <el-option key="1" label="禁用" value="1"/>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :span="4">
                        <el-form-item style="margin-top: 41px;">
                            <el-button type="primary" size="small" plain @click="search()">查询</el-button>
                        </el-form-item>
                    </el-col>
                    <el-col :span="4">
                        <el-form-item style="margin-top: 41px;margin-left:-151px;">
                            <el-button
                            type="primary"
                            plain
                            icon="el-icon-plus"
                            size="mini"
                            @click="handleAdd"
                            >新增字典数据</el-button>
                        </el-form-item>
                    </el-col>
                </el-row>
            </el-form> 
           
            <el-table
                    :data="dictDataList"
                    border
                    highlight-current-row
                    v-loading="loading"
                    style="width: 100%"
                >
                <!-- <el-table-column
                        type="index"
                        label="序号"
                        width="50" :index="indexMethod">
                </el-table-column> -->
                <el-table-column label="字典排序" align="center" prop="dictSort" />
                <el-table-column label="字典标签" align="center" prop="dictLabel" width="200">
                    <template slot-scope="scope">
                        {{ scope.row.dictLabel }}
                    </template>
                </el-table-column>
                <el-table-column label="字典标签英文" align="center" prop="dictLabelEn" width="390">
                    <template slot-scope="scope">
                        {{ scope.row.dictLabelEn }}
                    </template>
                </el-table-column>
                <el-table-column label="字典键值" align="center" prop="dictValue" />
                <el-table-column label="状态" align="center" prop="status">
                    <template slot-scope="scope">
                        <el-tag :type="scope.row.status === '0' ? 'success' : 'danger'">{{ scope.row.status === '0' ? '可用' : '禁用' }}</el-tag>
                    </template>
                </el-table-column>
                <el-table-column label="备注" align="center" prop="remark" width="200"/>
                <el-table-column label="创建时间" align="center" prop="createTime" width="180" :formatter="dateFormat"/>
                <el-table-column label="操作" align="center">
                    <template slot-scope="scope">
                    <el-button
                        type="text"
                        @click="handleUpdate(scope.row)"
                    >修改</el-button>
                    <el-button
                        type="text"
                        @click="handleDelete(scope.row)"
                    >删除</el-button>
                    </template>
                </el-table-column>                
            </el-table>
            <!-- 分页组件 -->
            <el-pagination
                background
                layout="total, sizes, prev, pager, next, jumper"
                :total="searchData.total"
                :page-sizes="[10, 20, 50]"
                :page-size="searchData.pageSize"
                :current-page.sync="searchData.pageNumber"
                @current-change="handlePageChange"
                @size-change="handleSizeChange"
                style="margin-top: 10px; float: right; margin-right: 10px"
            ></el-pagination>
        </el-main>
        <!-- 添加或修改参数配置对话框 -->
        <el-dialog :title="title" :visible.sync="open" width="500px" append-to-body>
        <el-form ref="form" :model="form" :rules="rules" label-width="120px">
            <el-form-item label="字典类型">
            <el-input v-model="form.dictType" :disabled="true" />
            </el-form-item>
            <el-form-item label="数据键值" prop="dictValue">
            <el-input v-model="form.dictValue" placeholder="请输入数据键值" />
            </el-form-item>
            <el-form-item label="数据标签" prop="dictLabel">
            <el-input v-model="form.dictLabel" placeholder="请输入数据标签" />
            </el-form-item>
            <el-form-item label="数据标签英文" prop="dictLabelEn">
            <el-input v-model="form.dictLabelEn" placeholder="请输入数据标签英文" />
            </el-form-item>
            <el-form-item label="显示排序" prop="dictSort">
            <el-input-number v-model="form.dictSort" controls-position="right" :min="0" />
            </el-form-item>
            <el-form-item label="状态" prop="status">
            <el-radio-group v-model="form.status">
                <el-radio key="0" label="0">可用</el-radio>
                <el-radio key="1" label="1">禁用</el-radio>
            </el-radio-group>
            </el-form-item>
            <el-form-item label="备注" prop="remark">
            <el-input v-model="form.remark" type="textarea" placeholder="请输入内容"></el-input>
            </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
            <el-button type="primary" @click="submitForm">确 定</el-button>
            <el-button @click="cancel">取 消</el-button>
        </div>
        </el-dialog>
    </el-container>
</template>

<script>
    import https from '@/https.js'
    import {dateFormat} from '@/api/utils.js'
    export default {
        name: "Dict",
        components: {            
        },
        data() {           
            return {
                 // 遮罩层
                loading: true,
                dictDataList:[],
                // 弹出层标题
                title: "",
                // 是否显示弹出层
                open: false,             
                searchData: {
                    pageNumber: 1,
                    pageSize: 10,
                    dictLabel: '',
                    status: '',
                    dictType:''
                },         
                // 表单参数
                form: {
                    dictCode: null,
                    dictLabel: '',
                    dictLabelEn:'',
                    dictType: '',
                    dictValue:'',
                    dictSort:null,
                    status: "0",
                    remark: ''
                },
                // 表单校验
                rules: {
                    dictLabel: [
                    { required: true, message: "数据标签不能为空", trigger: "blur" }
                    ],
                    dictLabelEn: [
                    { required: true, message: "数据标签英文不能为空", trigger: "blur" }
                    ],
                    dictType: [
                    { required: true, message: "字典类型不能为空", trigger: "blur" }
                    ],
                    dictValue:[
                    { required: true, message: "数据键值不能为空", trigger: "blur" }
                    ],
                    dictSort: [
                    { required: true, message: "数据顺序不能为空", trigger: "blur" }
                    ],
                    status: [
                    { required: true, message: "状态不能为空", trigger: "blur" }
                    ]
                }
            }
        },
        methods: {   
            search(val) {
                let params = this.searchData;
                console.log('param',params);
                https.fetchGet('/sysDictData/list',JSON.parse(JSON.stringify(params)),"json" ).then((data) => {
                console.log('data',data);
                let code = data.status;
                if(code == '200') {
                    this.dictDataList = data.data.list
                    console.log(' this.dictDataList', this.dictDataList);
                    // 2. 更新分页信息
                    this.searchData.total = data.data.total;
                    this.searchData.pageNumber = data.data.pageNum;
                    this.loading = false;

                }
                }).catch(err=>{
                        console.log(err)
                    }
                )
            },
            dateFormat(row, column, cellValue, index) {
                if(cellValue != null) {
                    return dateFormat(cellValue);
                } else {
                    return cellValue
                }
            },  
             handleSizeChange(val) {
                this.searchData.pageSize = val
                this.search()
            },
            handlePageChange(val) {
                this.searchData.pageNumber = val
                this.search()
            },
            // 格式化序号
            indexMethod(index) {
                return (this.searchData.pageNumber - 1) * this.searchData.pageSize + index + 1
            },  
            // 取消按钮
            cancel() {
                this.open = false;
                this.reset();
            },
            // 表单重置
            reset() {
                this.form = {
                    dictCode: null,
                    dictLabel: '',
                    dictLabelEn:'',
                    dictType: '',
                    dictValue:'',
                    dictSort:null,
                    status: "0",
                    remark: ''
                };
            },  
            /** 新增按钮操作 */
            handleAdd() {
                this.reset();
                this.open = true;
                this.title = "添加字典数据";
                this.form.dictType = this.$route.params.dictType
            }, 
            /** 提交按钮 */
            submitForm: function() {
            this.$refs["form"].validate(valid => {
                if (valid) {
                if (this.form.dictCode != undefined) {
                    https.fetchPost('/sysDictData/editDictData',this.form,"json" ).then((data) => {
                        console.log('data',data);
                        let code = data.status;
                        if(code == '200') {
                            this.$message({
                                message: '操作成功',
                                type: 'success'
                            });
                            this.open = false;
                            this.search();
                        }
                    }).catch(err=>{
                            console.log(err)
                        }
                    )
                } else {
                    https.fetchPost('/sysDictData/addDictData',this.form,"json" ).then((data) => {
                        console.log('data',data);
                        let code = data.status;
                        if(code == '200') {
                            this.$message({
                                message: '操作成功',
                                type: 'success'
                            });
                            this.open = false;
                            this.search();
                        }
                    }).catch(err=>{
                            console.log(err)
                        }
                    )
                }
                }
            });
            },
            /** 修改按钮操作 */
            handleUpdate(row) {
              this.reset();
              const dictCode = row.dictCode;
              this.form = row;
              this.open = true;
              this.title = "修改字典数据";
            },  
            /** 删除按钮操作 */
            handleDelete(row) {
                const dictCode = row.dictCode;
                this.$confirm('确认删除名称为"'+ row.dictLabel +'"的数据项?,是否继续?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
                }).then(() => {
                let params = {'dictCode': dictCode};
                https.fetchPost('/sysDictData/deleteDictData', params, 'json').then((data) => {
                    let code = data.data.code;
                    let msg = data.data.msg;
                    if (code == '200') {
                    this.$message({
                        type: 'success',
                        message: '删除成功!'
                    });
                    this.search();
                    } else {
                    this.$message({
                        type: 'info',
                        message: '删除失败：' + msg
                    });
                    }
                }).catch(err => {
                        this.$message.error('网络异常！');
                    }
                );
                }).catch(() => {
                this.$message({
                    type: 'info',
                    message: '已取消删除'
                });
                });
            },                                         
            showDictData(row){
                console.log(row);
                this.$router.push({
                    name: 'DictDataList',
                    params: row
                });
            },             
        },
        created: function () {
            let dictTypeData = this.$route.params;
            console.log('dictTypeData',dictTypeData);
            if(dictTypeData){
                this.searchData.dictType = dictTypeData.dictType;
            }
            this.search();
        }
    }
</script>

<style scoped>
.add-button {
    margin-bottom: 5px;
}
.but-cls {
    margin-bottom: 10px;
}
.cls-col {
    margin-right: 20px;
}
.el-input.is-disabled .el-input__inner,.el-input.is-disabled .el-textarea__inner{
    color:#000;
}
</style>